import { render } from "./PointMutiPromotion.vue?vue&type=template&id=47b54934"
import script from "./PointMutiPromotion.vue?vue&type=script&lang=js"
export * from "./PointMutiPromotion.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__